// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--wSQwr","icon":"styles-module--icon--ByVIk","copy":"styles-module--copy--1xLiO"};